/* RESPONSIBLE TEAM: team-data-foundations */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default class InsertableAction extends EmbercomBaseSerializer.extend(EmbeddedRecordsMixin) {
  attrs = {
    ruleset: { embedded: 'always' },
  };
}
